export default __webpack_public_path__ + "static/media/season_winter.4b045152.webp";